// @ts-nocheck
import React, { Fragment } from 'react';
// material
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import FormHelperText from '@material-ui/core/FormHelperText';
import { Paper, List } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
// utils
// icons
import AddIcon from '@material-ui/icons/Add';
// components
import WeightField from '../../../../commons/containers/WeightField';
import { truthty, falsy, getUnitDetails } from '../../../../utils/functions';
import LotListItem from '../LotListItem';

function ReturnedLots(props) {
  const {
    controls,
    changeControls,
    invalidControls,
    fruits,
    varieties,
    products,
    objects,
    packagingTypes,
    changeWeight,
    warehouses,
    addReturnedLot,
    classes,
  } = props;
  const { t } = useTranslation();

  const { unitCode, unitName } = getUnitDetails(objects.accounts);

  const { quantity, packagingTypeId, packagingQuantity } = controls;
  let totalWeight = 0;
  if (truthty(quantity) && truthty(packagingTypeId) && truthty(packagingQuantity)) {
    totalWeight = quantity - packagingTypes[packagingTypeId].weight * packagingQuantity;
  }

  const disabledAddButton =
    falsy(controls.packagingQuantity) ||
    controls.packagingQuantity <= 0 ||
    falsy(controls.quantity) ||
    controls.quantity <= 0 ||
    falsy(controls.warehouseId);

  const returnLotForm = (
    <>
      <Grid item sm={6} xs={12}>
        <FormControl fullWidth>
          <InputLabel id="fruit-label">{t('Species')}</InputLabel>
          <Select
            labelId="fruit-label"
            fullWidth
            value={controls.fruitId}
            onChange={changeControls}
            error={invalidControls.fruitId}
            disabled>
            <MenuItem id="fruitId" value="" data-module="departure">
              {t('None')}
            </MenuItem>
            {Object.values(fruits).map((fruit) => (
              <MenuItem
                key={`fruit-option-${fruit.id}`}
                id="fruitId"
                value={fruit.id}
                data-module="departure">
                {fruit.name}
              </MenuItem>
            ))}
          </Select>
          {truthty(invalidControls.fruitId) && (
            <FormHelperText error>{t('Species required')}</FormHelperText>
          )}
        </FormControl>
      </Grid>
      <Grid item sm={6} xs={12}>
        <FormControl fullWidth>
          <InputLabel id="variety-label">{t('Variety')}</InputLabel>
          <Select
            labelId="variety-label"
            fullWidth
            value={controls.varietyId}
            onChange={changeControls}
            error={invalidControls.varietyId}
            disabled>
            <MenuItem id="varietyId" value="" data-module="departure">
              {t('None')}
            </MenuItem>
            {Object.values(varieties).map((variety) => (
              <MenuItem
                key={`variety-option-${variety.id}`}
                id="varietyId"
                value={variety.id}
                data-module="departure">
                {variety.name}
              </MenuItem>
            ))}
          </Select>
          {truthty(invalidControls.varietyId) && (
            <FormHelperText error>{t('Variety required')}</FormHelperText>
          )}
        </FormControl>
      </Grid>
      <Grid item sm={6} xs={12}>
        <FormControl fullWidth>
          <InputLabel id="product-label">{t('Product')}</InputLabel>
          <Select
            labelId="product-label"
            fullWidth
            value={controls.productId}
            onChange={changeControls}
            error={invalidControls.productId}
            disabled>
            <MenuItem id="productId" value="" data-module="departure">
              {t('None')}
            </MenuItem>
            {Object.values(products).map((product) => (
              <MenuItem
                key={`product-option-${product.id}`}
                id="productId"
                value={product.id}
                data-module="departure">
                {product.name}
              </MenuItem>
            ))}
          </Select>
          {truthty(invalidControls.productId) && (
            <FormHelperText error>{t('Product required')}</FormHelperText>
          )}
        </FormControl>
      </Grid>
      <Grid item sm={6} xs={12}>
        <WeightField
          quantity={controls.quantity}
          changeWeight={changeWeight}
          changeControls={changeControls}
          error={invalidControls.quantity}
          helperText={invalidControls.quantity && t('Enter the quantity of', { unit: unitName })}
          totalWeight={totalWeight}
          label={unitCode}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <FormControl fullWidth>
          <InputLabel id="container-label">{t('Container')}</InputLabel>
          <Select
            labelId="container-label"
            fullWidth
            value={controls.packagingTypeId}
            onChange={changeControls}
            error={invalidControls.packagingTypeId}
            disabled>
            <MenuItem id="containerId" value="" data-module="departure">
              {t('None')}
            </MenuItem>
            {Object.values(packagingTypes).map((packagingType) => (
              <MenuItem
                key={`packaging-type-option-${packagingType.id}`}
                id="packagingTypeId"
                value={packagingType.id}
                data-module="departure">
                {packagingType.name}
              </MenuItem>
            ))}
          </Select>
          {truthty(invalidControls.packagingTypeId) && (
            <FormHelperText error>{t('Enter a packaging type')}</FormHelperText>
          )}
        </FormControl>
      </Grid>
      <Grid item sm={6} xs={12}>
        <TextField
          value={controls.packagingQuantity}
          onChange={changeControls}
          fullWidth
          id="packagingQuantity"
          label={t('packaging quantity')}
          inputProps={{ 'data-module': 'departure' }}
          error={invalidControls.packagingQuantity}
          helperText={invalidControls.packagingQuantity && t('enter packaging quantity error')}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <FormControl fullWidth>
          <InputLabel id="warehouse-label">{t('Warehouse')}</InputLabel>
          <Select
            labelId="warehouse-label"
            fullWidth
            value={controls.warehouseId}
            onChange={changeControls}
            error={invalidControls.warehouseId}>
            <MenuItem id="warehouseId" value="" data-module="departure">
              {t('None')}
            </MenuItem>
            {Object.values(warehouses)
              .filter((wh) => !wh.supplyWarehouse)
              .map((warehouse) => (
                <MenuItem
                  key={`warehouse-option-${warehouse.id}`}
                  id="warehouseId"
                  value={warehouse.id}
                  data-module="departure">
                  {warehouse.name}
                </MenuItem>
              ))}
          </Select>
          {truthty(invalidControls.warehouseId) && (
            <FormHelperText error>{t('Warehouse required')}</FormHelperText>
          )}
        </FormControl>
      </Grid>
      <Grid item sm={6} xs={12}>
        <Button
          fullWidth
          size="small"
          startIcon={<AddIcon />}
          onClick={addReturnedLot}
          variant="contained"
          className={classes.filterButton}
          color="primary"
          disabled={disabledAddButton}>
          {t('Add')}
        </Button>
      </Grid>
    </>
  );

  return (
    <Grid item container sm={6} xs={12} spacing={1}>
      <Grid item xs={12}>
        <Typography gutterBottom variant="h6" component="h6">
          {t('Reprocessed paks')}
        </Typography>
      </Grid>
      {returnLotForm}
      <Grid item xs={12}>
        <Paper style={{ padding: 30, margin: 10 }}>
          <List dense>
            {controls.returnedLots.map((l, index) => (
              <LotListItem
                key={`returned-lot-${l.fruitId}-${l.quantity}`}
                lot={l}
                objects={objects}
                index={index}
                product={products[l.productId]}
                classes={classes}
                addToReturnLots={props.addToReturnLots}
                deleteFnc={props.deleteReturnedLot}
              />
            ))}
          </List>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default ReturnedLots;
